export default "__VITE_ASSET__CVbQzqLf__"